// bernie
import { ClientFactories, Store } from 'bernie-core';
import { NOOP_LOGGER } from 'bernie-logger';
import { ClientLogger } from 'bernie-client';

// data
import {
  LegalSource,
  ProductSource,
  ProgramSource,
  PzCampaignSource,
  PzSource,
  UserAuthSource,
  UserSource,
  PzOAuthSource,
} from '../sources';
import {
  AccountDataStateStore,
  CaptchaStore,
  CountriesStore,
  IndustryStore,
  LegalStore,
  LinkStore,
  ProductStore,
  ProgramStore,
  PzCampaignStore,
  PzOAuthStore,
  PzStore,
  QuicklinkStore,
  UiStore,
  UserAuthStore,
  UserStore,
} from '.';
import AffiliateHubLogger from '../util/affiliate-hub-logger';

const { getLoggerWithIdentifier } = ClientLogger;

export const stores: ClientFactories = {
  captcha: (): Store => new CaptchaStore(),
  countriesStore: (): Store => new CountriesStore({}, NOOP_LOGGER),
  industries: (): Store => new IndustryStore({}, NOOP_LOGGER),
  legal: (): Store => new LegalStore(new LegalSource({})),
  link: (): Store => new LinkStore(new LinkStore({}, NOOP_LOGGER)),
  products: (): Store => new ProductStore(new ProductSource({}), {}, NOOP_LOGGER),
  programs: (): Store => new ProgramStore(new ProgramSource([]), {}, NOOP_LOGGER),
  quicklinks: (): Store => new QuicklinkStore({}, NOOP_LOGGER),
  user: (): Store => new UserStore(new UserSource(), {}, NOOP_LOGGER),
  userAuth: (): Store =>
    new UserAuthStore(new UserAuthSource(null), {}, new AffiliateHubLogger(getLoggerWithIdentifier('store.userAuth'))),
  pzStore: (): Store => new PzStore(new PzSource(), {}, NOOP_LOGGER),
  pzCampaignStore: (): Store => new PzCampaignStore(new PzCampaignSource(), {}, NOOP_LOGGER),
  uiStore: (): Store => new UiStore({}, {}, NOOP_LOGGER),
  accountDataStateStore: (): Store =>
    new AccountDataStateStore({}, new AffiliateHubLogger(getLoggerWithIdentifier('store.appBootstrap'))),
  pzOAuthStore: (): Store =>
    new PzOAuthStore(
      new PzOAuthSource(new AffiliateHubLogger(getLoggerWithIdentifier('source.pzOAuthSource'))),
      {},
      new AffiliateHubLogger(getLoggerWithIdentifier('store.pzOAuthStore')),
    ),
};
